import React, { useContext, useEffect, useMemo } from "react";

import classNames from "classnames";
import { observer } from "mobx-react";

import ComponentContext from "../../../contexts/ComponentContext";
import { useStores } from "../../../contexts/StoreContext";
import BoxLink from "./BoxLink";

function BoxLinks() {
  const { filtersStore } = useStores();
  const { setFiltersMapping } = filtersStore;

  const { boxLinks, imagesInRow, boxWidth, boxHeight, alignment } =
    useContext(ComponentContext);

  useEffect(() => {
    const filtersMapping = boxLinks.reduce((acc, curr) => {
      if (!curr.filterMap) {
        return acc;
      }

      acc[curr.name] = {
        filterName: curr.filterName,
        filterValue: curr.filterMap.split("\n"),
      };
      return acc;
    }, {});

    setFiltersMapping(filtersMapping);
  }, []);

  /* eslint-disable sort-keys */
  const imagesRowMap = {
    two: 2,
    three: 3,
    four: 4,
    five: 5,
    six: 6,
  };
  /* eslint-enable sort-keys */

  const alignmentClass = classNames({
    "justify-content-start": alignment === "start",
    "justify-content-end": alignment === "end",
    "justify-content-center": alignment === "center",
    "justify-content-between": alignment === "between",
    "justify-content-around": alignment === "around",
    "justify-content-evenly": alignment === "evenly",
  });

  const columnValue = useMemo(
    () => 12 / imagesRowMap[imagesInRow],
    [imagesInRow]
  );

  return (
    <div className={classNames("row", alignmentClass)}>
      {boxLinks.map((boxLink) => (
        <BoxLink
          key={`${boxLink.name}-${boxLink.id}`}
          boxDimensions={{ height: boxHeight, width: boxWidth }}
          boxLink={boxLink}
          columnValue={columnValue}
        />
      ))}
    </div>
  );
}

export default observer(BoxLinks);
